import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 100vw;
  padding: 30px;
  box-sizing: border-box;
  max-height: calc(100vh - 60px);
`;

export const Message = styled.div`
  font-size: 20px;
`;

export const Emoji = styled.div`
  font-size: 100px;
  text-align: center;
  margin-top: 50px;
  margin-bottom: 20px;
`;
